import React from "react";
import { Pressable, Text, TextInput, View } from "react-native";

import { devStyles as s } from "./devStyles";

export const Btn: React.FC<{
  label: string;
  onPress: () => void;
  on?: boolean;
  disabled?: boolean;
  testID?: string;
}> = ({ label, onPress, on, disabled, testID }) => (
  <Pressable
    testID={testID}
    accessibilityRole="button"
    accessibilityState={{ selected: !!on, disabled: !!disabled }}
    disabled={disabled}
    onPress={onPress}
    style={[s.btn, on && s.on, disabled && s.disabled]}
  >
    <Text style={s.text}>{label}</Text>
  </Pressable>
);

/** A labelled on/off switch drawn as a checkbox-style button. */
export const Toggle: React.FC<{
  label: string;
  value: boolean;
  onChange: (v: boolean) => void;
  testID?: string;
}> = ({ label, value, onChange, testID }) => (
  <Pressable
    testID={testID}
    accessibilityRole="switch"
    accessibilityState={{ checked: value }}
    onPress={() => onChange(!value)}
    style={s.row}
  >
    <Text style={s.text}>{value ? "☑" : "☐"}</Text>
    <Text style={s.text}>{label}</Text>
  </Pressable>
);

export const Field: React.FC<{
  value: string;
  onChange: (v: string) => void;
  placeholder: string;
  testID?: string;
  numeric?: boolean;
}> = ({ value, onChange, placeholder, testID, numeric }) => (
  <TextInput
    testID={testID}
    value={value}
    onChangeText={onChange}
    placeholder={placeholder}
    placeholderTextColor="#5A5F66"
    autoCapitalize="none"
    autoCorrect={false}
    keyboardType={numeric ? "numeric" : "default"}
    style={s.input}
  />
);

export const Row: React.FC<{ children: React.ReactNode; wrap?: boolean }> = ({
  children,
  wrap,
}) => <View style={[s.row, wrap && s.wrap]}>{children}</View>;

export const Note: React.FC<{ children: React.ReactNode; error?: boolean }> = ({
  children,
  error,
}) => <Text style={error ? s.error : s.dim}>{children}</Text>;
